#import "../fragments/work-os-fragment.graphql"

query GetWorkOsInformation {
    workOs {
        ...WorkOsFragment
    }
}
